<template>
    <div
        class="product-card-nutra-rating"
        :class="{ 'product-card-nutra-rating--simple': simple, 'product-card-nutra-rating--big': big }"
        @click="clicked"
    >
        <div v-if="showInfoBox" class="product-card-nutra-rating__info-box">
            {{ $t('productDetail.nutraRating.popupDescription') }}
        </div>
        <div v-if="!big" class="product-card-nutra-rating__title">
            {{ $t('productDetail.nutraRating.title') }}
        </div>
        <div class="product-card-nutra-rating__value">
            <div
                class="product-card-nutra-rating__value--a-plus"
                :class="{ 'product-card-nutra-rating__value--active': nutraRatingLetter === 'A+' }"
            >
                A+
            </div>
            <div
                class="product-card-nutra-rating__value--a"
                :class="{ 'product-card-nutra-rating__value--active': nutraRatingLetter === 'A' }"
            >
                A
            </div>
            <div
                class="product-card-nutra-rating__value--b"
                :class="{ 'product-card-nutra-rating__value--active': nutraRatingLetter === 'B' }"
            >
                B
            </div>
            <div
                class="product-card-nutra-rating__value--c"
                :class="{ 'product-card-nutra-rating__value--active': nutraRatingLetter === 'C' }"
            >
                C
            </div>
            <div
                class="product-card-nutra-rating__value--d"
                :class="{ 'product-card-nutra-rating__value--active': nutraRatingLetter === 'D' }"
            >
                D
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        nutraRatingLetter: string
        simple?: boolean
        big?: boolean
        showInfoBox?: boolean
    }>(),
    {
        simple: false,
        big: false,
        showInfoBox: true,
    }
)

const infoBoxOpened = ref(false)
const clicked = () => {
    infoBoxOpened.value = !infoBoxOpened.value
}
</script>

<style scoped lang="scss">
.product-card-nutra-rating {
    border-radius: 10px;
    display: flex;
    margin: 0;
    position: relative;
    align-items: center;
    //justify-content: center;

    &__title {
        color: $color-grey-500;
        font-size: 14px;
        font-weight: 600;
        padding-right: 10px;
        white-space: nowrap;
    }

    &__value {
        padding: 0 10px 0 0;
        border-radius: 4px;
        font-weight: 600;
        font-size: 11px;
        color: $color-white;
        display: flex;
        align-items: center;

        * {
            height: 24px;
            width: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 24px;
        }

        &--active {
            height: 40px;
            width: 36px;
            border-radius: 4px;
            font-size: 16px;
        }

        &--a-plus {
            background: #73be4c;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }

        &--a {
            background: #94d769;
        }

        &--b {
            background: #deeb88;
        }

        &--c {
            background: #ebc10f;
        }

        &--d {
            background: #e59819;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }

    &--simple {
        .product-card-nutra-rating__value {
            * {
                display: none;
                width: 23px;
                height: 24px;
                font-size: 13px;
            }

            &--active {
                display: flex;
            }
        }
    }

    &--big {
        .product-card-nutra-rating__value {
            * {
                //display: none;
                width: 33px;
                height: 34px;
                font-size: 17px;
            }

            &--active {
                display: flex;
                width: 53px;
                height: 54px;
                font-size: 25px;
            }
        }
    }

    &__info-box {
        display: none;
        background: #e7f8ff;
        position: absolute;
        bottom: calc(100% + 10px);
        left: 50%;
        margin-top: -10px;
        margin-left: -100px;
        width: 200px;
        text-transform: none;
        color: $color-dark;
        font-size: 14px;
        padding: 10px 10px;
        line-height: 18px;
        border-radius: 10px;
        z-index: 20;

        &::before {
            content: '';
            position: absolute;
            top: calc(100% - 5px);
            left: 50%;
            margin-left: -10px;
            width: 12px;
            height: 12px;
            background: #e7f8ff;
            transform: rotate(45deg);
        }
    }

    &:hover {
        @include screen-md {
            .product-card-nutra-rating__info-box {
                display: block;
            }
        }
    }

    &--opened {
        .product-card-nutra-rating__info-box {
            display: block;
        }
    }
}
</style>
